import styled from "@emotion/styled";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useLayoutUI } from "../hooks/useLayoutUI";
import { Color } from "../components/styles/enums";

import { AppHeader } from "../components/common/header/appHeader";

type Props = {
  status?: number;
};

const PageWrapper = styled.div`
  background-color: ${Color.PRIMARY};
  padding: 30px 20px 180px;
  max-width: 960px;
  margin: auto;

  > pre {
    white-space: pre-wrap;
  }
`;

const STATUS_CODES: {
  [errorCode: number]: string | undefined;
  [errorCode: string]: string | undefined;
} = {
  100: "Continue",
  101: "Switching Protocols",
  102: "Processing",
  200: "OK",
  201: "Created",
  202: "Accepted",
  203: "Non-Authoritative Information",
  204: "No Content",
  205: "Reset Content",
  206: "Partial Content",
  207: "Multi-Status",
  208: "Already Reported",
  226: "IM Used",
  300: "Multiple Choices",
  301: "Moved Permanently",
  302: "Found",
  303: "See Other",
  304: "Not Modified",
  305: "Use Proxy",
  307: "Temporary Redirect",
  308: "Permanent Redirect",
  400: "Bad Request",
  401: "Unauthorized",
  402: "Payment Required",
  403: "Forbidden",
  404: "Not Found",
  405: "Method Not Allowed",
  406: "Not Acceptable",
  407: "Proxy Authentication Required",
  408: "Request Timeout",
  409: "Conflict",
  410: "Gone",
  411: "Length Required",
  412: "Precondition Failed",
  413: "Payload Too Large",
  414: "URI Too Long",
  415: "Unsupported Media Type",
  416: "Range Not Satisfiable",
  417: "Expectation Failed",
  418: "I'm a teapot",
  421: "Misdirected Request",
  422: "Unprocessable Entity",
  423: "Locked",
  424: "Failed Dependency",
  425: "Unordered Collection",
  426: "Upgrade Required",
  428: "Precondition Required",
  429: "Too Many Requests",
  431: "Request Header Fields Too Large",
  451: "Unavailable For Legal Reasons",
  500: "Internal Server Error",
  501: "Not Implemented",
  502: "Bad Gateway",
  503: "Service Unavailable",
  504: "Gateway Timeout",
  505: "HTTP Version Not Supported",
  506: "Variant Also Negotiates",
  507: "Insufficient Storage",
  508: "Loop Detected",
  509: "Bandwidth Limit Exceeded",
  510: "Not Extended",
  511: "Network Authentication Required",
};

export const GenericErrorContainer: React.FC<Props> = ({ status }) => {
  const { setLayout } = useLayoutUI();
  const { type } = useParams<{ type?: string }>();

  let title = (status && STATUS_CODES[status]) || "Internal Error";
  let msg = "";
  if (type === "invalid_token") {
    title = "認証エラー";
    msg = "エラーが発生しました。しばらくしてからもう一度お試しください。";
  }

  useEffect(() => {
    setLayout({
      title: "エラー",
    });
  }, [setLayout]);

  return (
    <div>
      <AppHeader title="エラー" noBackButton moreButton={false} />
      <PageWrapper>
        <h1>{title}</h1>
        <pre>{status || msg}</pre>
      </PageWrapper>
    </div>
  );
};
